'use client'
import { SnackbarProvider } from 'notistack'

const SnackbarWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'bottom', // Change to "bottom" if needed
        horizontal: 'right',
      }}
      maxSnack={3}
    >
      {children}
    </SnackbarProvider>
  )
}

export default SnackbarWrapper
